<template lang="html">
  <div class="home-hero">
    <main-header></main-header>
    <section class="hero__bg">
      <img src="/static/images/case-studies/covidien/covidien-hero.jpg" alt="">
      <div class="hero__content">
        <h2>turn key mobile tours</h2>
        <p>driving the brand experience</p>
        <span class="down-arrow"></span>
      </div>
    </section>
  </div>
</template>

<script>
  import Header from '@/components/Header'

  export default {
    components: {
      'main-header': Header
    },
    name: 'home-hero',
    data () {
      return {

      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .home-hero {
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: 75px auto;

    height: 100vh;
    width: 100%;

    @include breakpoint($md) {
      grid-template-rows: 120px auto;
    }
  }

  .hero__bg {
    position: relative;
    grid-column: 1 / 2;
    grid-row: 1 / 3;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;

    > img {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 50% 50%;
      vertical-align: middle;
    }
  }

  .hero__content {
    grid-column: 1 / 2;
    grid-row: 3 / 4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 20;
    h2 {
      margin: 1rem 0;
      font-family: $barlowCondensed;
      font-size: 3rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 3px;
      color: $white;
      @include breakpoint($md) {
        font-size: 6vw;
      }
      @include breakpoint(100rem) {
        font-size: 6rem;
      }
    }

    p {
      margin: 0;
      font-family: $montserrat;
      font-size: 1.125rem;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 3px;
      color: $light-blue;
    }
  }

  .down-arrow {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    margin: 3.750rem 0 2.500rem 0;
    height: 2.813rem;
    width: 2.813rem;
    border-radius: 100%;
    border: 1px solid $white;
    &::after {
      position: relative;
      display: block;
      content: '';
      height: 5px;
      width: 5px;
      transform: rotate(45deg);
      border-bottom: 1px solid $white;
      border-right: 1px solid $white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeHero.vue